import { select } from '@panel/commons/core/themev2';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Divider = styled.div`
  background-color: ${select('neutralDarkGray')};
  height: 1px;
  width: 100%;
  margin: 16px 0;
`;

export { Container, Divider };
